module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0762.7041a066.jpg";